<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog work_order_feedback_form"
        title="每日工作填写"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body" v-if="dialogVisible">
            <el-form
                ref="workOrderFeedBackForm"
                :model="workOrderFeedBackForm"
                :rules="workOrderFeedBackFormRules"
                label-position="top"
                size="small"
            >
                <el-form-item label="日期" prop="work_date">
                    <el-date-picker
                        v-model="workOrderFeedBackForm.work_date"
                        format="yyyy-MM-dd"
                        placeholder="请选择"
                        size="small"
                        type="date"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="管理打卡记录" prop="clock_id" :rules="rules">
                    <div class="select-author-btn" @click="handleChangeClockRecord">
                        <div>
                            <span
                                :class="{ 'text-bold': selectClockInRecordData && selectClockInRecordData.dateTxt }"
                                >{{ selectClockInRecordData.dateTxt || "请选择打卡记录" }}</span
                            >
                        </div>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </el-form-item>
                <el-form-item label="工作内容" prop="work_content">
                    <div class="comment_wrap">
                        <el-input
                            v-model="workOrderFeedBackForm.work_content"
                            :rows="5"
                            maxlength="500"
                            placeholder="请输入"
                            type="textarea"
                        ></el-input>
                        <div class="commentImages">
                            <ul>
                                <li v-for="(item, key) in imageList" :key="key">
                                    <i @click="handleClickDelImage(key)" class="iconfont icon-guanbi_dise"></i>
                                    <img :src="item.file_path" alt="" />
                                </li>
                            </ul>
                        </div>
                        <div class="commentFiles">
                            <ul>
                                <li v-for="(file, fileIndex) in fileList" :key="fileIndex">
                                    <p class="ellipsis" v-text="file.file_name"></p>
                                    <div>
                                        <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                            <i class="iconfont icon-yanjing"></i>
                                        </span>
                                        <span class="handle_icon_wrap" @click="handleClickDelFile(fileIndex)">
                                            <i class="iconfont icon-shanchu1"></i>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="commentHandle">
                            <div>
                                <span class="handle_icon_wrap" @click="handleClickCommentUpload('file')">
                                    <i class="iconfont icon-lianjie"></i>
                                </span>
                                <span class="handle_icon_wrap" @click="handleClickCommentUpload('image')">
                                    <i class="iconfont icon-tupian"></i>
                                </span>
                            </div>
                            <span class="word_count">{{ workOrderFeedBackForm.work_content.length }}/500</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
        <ClockRecordSelect
            :clockInRecordDialogVisible.sync="clockInRecordDialogVisible"
            v-if="clockInRecordDialogVisible"
            @selectClockIndata="selectedClockIndata"
        />
        <el-image
            :preview-src-list="previewImgList"
            :src="previewImgSrc"
            ref="preview_img"
            style="display: none"
        ></el-image>
    </el-dialog>
</template>
<script>
import { workOrderSetDetail, workOrderFeedBack } from "@/api";
import { uploadImg, getOSSData } from "@/utils/uploadOss";
import { formatFileSize, getNowDate } from "@/utils";
import ClockRecordSelect from "./clock_record_select.vue";
export default {
    name: "WorkOrderFeedBack",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
    },
    components: { ClockRecordSelect },
    data() {
        return {
            loading: false,
            workOrderFeedBackForm: {
                work_date: getNowDate(),
                work_content: "",

                clock_id: "",
            },
            workOrderFeedBackFormRules: {
                work_date: [{ required: true, message: "请选择日期", trigger: "change" }],
                work_content: [{ required: true, message: "请输入", trigger: "blur" }]
            },
            imageList: [],
            fileList: [],

            clockInRecordDialogVisible: false,
            selectClockInRecordData: {}, // 选择的数据

            is_clock: false, // 是否需现场打卡证明

            previewImgList: [],
            previewImgSrc: "",
        };
    },
    computed: {
        rules() {
            if (this.is_clock) {
                return [
                    {
                        required: true,
                        message: "请选择打卡记录",
                        trigger: ["blur", "change"],
                    },
                ];
            }
            return [];
        },
    },
    created() {
        this.getWorkOrderSetDetail();
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.workOrderFeedBackForm.clearValidate();
        });
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 获取是否需现场打卡证明
        getWorkOrderSetDetail() {
            this.loading = true;
            workOrderSetDetail()
                .then((res) => {
                    this.is_clock = res.data.is_clock == 1 ? true : false;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 选择打卡记录
        handleChangeClockRecord() {
            this.clockInRecordDialogVisible = true;
        },
        // 选择确认的打卡记录
        selectedClockIndata(data) {
            this.clockInRecordDialogVisible = false;
            this.selectClockInRecordData = data
                ? { ...data, dateTxt: data.punch_type == 'SINGLE' ? data.created_at: (data.start_time + "~" + (data.end_time || "")) }
                : {};
            this.$set(this.workOrderFeedBackForm, "clock_id", data ? data.id : "");
        },
        handleClickCommentUpload(type) {
            let that = this;
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            // input.setAttribute('multiple', 'multiple')
            if (type == "image") {
                input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            } else {
                input.setAttribute("accept", "");
            }
            input.click();
            input.onchange = function () {
                const file = this.files[0];
                if (type == "image" && file.type.indexOf("image") < 0) {
                    that.$message.error("请上传图片文件！");
                    return false;
                }
                that.loading = true;
                if (file) {
                    uploadImg(file)
                        .then((res) => {
                            if (res.file_path) {
                                if (type == "image") {
                                    that.imageList.push({ file_name: res.file_name, file_path: res.file_path });
                                } else {
                                    res.file_size = formatFileSize(file.size);
                                    that.fileList.push(res);
                                }
                            }
                            that.loading = false;
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                }
            };
        },
        handleClickDelImage(key) {
            this.imageList.splice(key, 1);
        },
        handleClickDelFile(key) {
            this.fileList.splice(key, 1);
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件类型不支持预览");
                }
            }
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.workOrderFeedBackForm.validate((valid) => {
                if (valid) {
                    const params = {
                        workorder_id: this.workorder_id,
                        work_date: this.workOrderFeedBackForm.work_date,
                        work_content: this.workOrderFeedBackForm.work_content,
                        clock_id: (this.selectClockInRecordData && this.selectClockInRecordData.id) || 0,
                        files: this.imageList.concat(this.fileList),
                    };
                    workOrderFeedBack(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message || "提交成功");
                            this.$emit("update:dialogVisible", false);
                            this.$emit("refreshList");
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.work_order_feedback_form {
    .select-author-btn {
        width: 100%;
        height: 32px;
        padding: 12px;
        opacity: 1;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;

        .el-icon-arrow-down {
            color: #666666;
        }

        &:active {
            border-color: #409eff;
        }

        .text-bold {
            color: rgba(51, 51, 51, 1);
        }
    }
    .comment_wrap {
        border: 1px solid rgba(217, 217, 217, 1);
        border-radius: 2px;
        box-sizing: border-box;
        min-height: 222px;
        position: relative;
        padding-bottom: 32px;
        .el-textarea .el-input__count {
            bottom: -42px !important;
            background-color: transparent;
        }
        .el-textarea__inner {
            border: 0 !important;
        }
        .commentImages {
            width: 100%;
            // position: absolute;
            ul {
                display: flex;
                flex-wrap: wrap;
                padding: 5px 12px 0;
                height: 40px;
                overflow: auto;
                box-sizing: border-box;
                li {
                    width: 32px;
                    margin-right: 8px;
                    position: relative;
                    margin-bottom: 8px;
                    img {
                        display: block;
                        width: 32px;
                        height: 32px;
                        border-radius: 4px;
                        object-fit: contain;
                    }
                    i {
                        position: absolute;
                        font-size: 12px;
                        right: -5px;
                        top: -5px;
                        text-align: center;
                        line-height: 12px;
                        cursor: pointer;
                        color: rgba(191, 191, 191, 1);
                    }
                }
            }
        }
        .commentFiles {
            // position: absolute;
            // bottom: 32px;
            width: 100%;
            ul {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                padding: 0 12px;
                min-height: 26px;
                max-height: 72px;
                overflow: auto;
                li {
                    width: calc(50% - 4px);
                    margin-bottom: 4px;
                    border-radius: 2px;
                    background: rgba(249, 249, 249, 1);
                    border: 1px solid rgba(217, 217, 217, 1);
                    line-height: 20px;
                    height: 22px;
                    padding: 0 8px;
                    box-sizing: border-box;
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    p {
                        font-size: 12px;
                        color: rgba(102, 102, 102, 1);
                        width: calc(100% - 50px);
                    }
                    div {
                        width: 40px;
                        display: flex;
                        justify-content: space-between;
                        span.handle_icon_wrap {
                            width: 16px;
                            height: 16px;
                            font-size: 12px;
                            line-height: 16px;
                            i {
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }
        .commentHandle {
            position: absolute;
            bottom: 0;
            width: 100%;
            padding: 0 8px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span + span {
                margin-left: 8px;
            }
            .word_count {
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);
            }
        }
    }
}
</style>
